import React from "react";
import './Feature.css';

const Feature = ({ feature }) => {

  // Split the title into two parts
  const words = feature.title.split(" ");
  const mid = Math.ceil(words.length / 2);
  const firstHalf = words.slice(0, mid).join(" ");
  const secondHalf = words.slice(mid).join(" ");

  return (
    <div className="feature-item">
      <div className="icon-box">
        <div className="top-icon">
          <div className="icon">{feature.icon}</div> {/* Feature icon */}
        </div>
      </div>
      <div className="content">
        <h3>{firstHalf} <br /> {secondHalf}</h3> {/* Feature title */}
        <p>{feature.description}</p> {/* Feature description */}
      </div>
    </div>
  );
};

export default Feature;